<template>
  <div class="login-box">
    <!-- <div class="nav_container">
      <div class="logo">
        <img src="../../../static/img/logos.png" alt="">
      </div>
      <div class="nav">
        <ul>
          <li class="navhover">
            <a @click="goto">首页</a>
          </li>
          <li class="navhover">
            <a href>产品中心</a>
            <div class="navchild">
              <div class="navchild1 navchild2">
                <a href="System.html">店务系统介绍</a>
              </div>
              <div class="navchild1 navchild2">
                <a href="Mall.html">供应链介绍</a>
              </div>
              <div class="navchild1">
                <a href="MarketingTool.html">营销工具介绍</a>
              </div>
            </div>
          </li>
          <li class="navhover">
            <a href="https://mei.zhaomeiw.com" target="https://mei.zhaomeiw.com">店务系统</a>
          </li>
          <li class="navhover">
            <a href="https://mall.zhaomeiw.com" target="https://mall.zhaomeiw.com">供应链商城</a>
          </li>
          <li class="navhover">
            <a
              href="http://mall.zhaomeiw.com/#/beautySay"
              target="http://mall.zhaomeiw.com/#/beautySay"
            >美业咨询</a>
          </li>
          <li class="navhover">
            <a href="AboutUsIntroduction.html">关于美服在线</a>
            <div class="navchildgywm">
              <div class="navchild1 navchild2">
                <a href="AboutUsGsjs.html">公司简介</a>
              </div>
              <div class="navchild1 navchild2">
                <a href="AboutUsQywh.html">合作渠道</a>
              </div>
              <div class="navchild1 navchild2">
                <a href="AboutUsGsdt.html">资讯招聘</a>
              </div>
              <div class="navchild1">
                <a href="AboutUsFzlc.html">企业文化</a>
              </div>
            </div>
          </li>
        </ul>
      </div>
      <div style="display: flex;align-items: center;position: absolute;top:0;right: 50px;">
        <img src alt />
        <div style="font-size:14px;color: #333;">简体中文</div>
      </div>
    </div> -->
  </div>
</template>
  
  <script>
import { mapMutations } from "vuex";
import * as commonApi from "api/common";

export default {
  props: {},
  data() {
    return {};
  },
  created() {},
  methods: {
    goto() {
      this.$router.push("/");
    }
  },
  mounted() {}
};
</script>
  <style>
</style>
  <style scoped lang="scss">
@import "../../assets/css/them.scss";

.login-box {
  width: 100%;
  height: 100%;
  /* position: fixed; */
  background: #fff;
  /* left: 0;
      top: 0; */
}

/* .nav_container {
  background: #fff;
  border-radius: 8px;
  height: 60px;
  line-height: 60px;
  width: 1200px;
  margin-left: 360px;
  position: absolute;
  top: 20px;
  z-index: 10;
  display: flex;
  align-items: center;
}

.logo {
  width: 200px;
  height: 40px;
} */

.logo img {
  width: 100%;
  height: 100%;
}

.nav {
  width: 690px;
  height: 80px;
  margin: 0 auto;
  line-height: 80px;
  font-size: 14px;
  float: right;
  color: #222;
}

.nav ul li {
  float: left;
  display: block;
  height: 80px;
  line-height: 80px;
  padding: 0 20px;
  position: relative;
}

.navhover::before {
  content: "";
  position: absolute;
  top: 60px;
  left: 100%;
  width: 0;
  height: 0;
  border-bottom: 2px solid #4cb2ed;
  transition: 0.2s all linear;
}

.navhover:hover::before {
  width: 100%;
  top: 60px;
  left: 0;
  transition-delay: 0.1s;
  border-bottom-color: #4cb2ed;
}

.navhover:hover ~ .navhover::before {
  left: 0;
}

.navhover:active {
  color: #fff;
}

.nav ul li a {
  text-decoration: none;
  color: #222;
  display: block;
  /* transition: 1s ; */
}

.navhover {
  position: relative;
  transition: 0.1s all linear;
  cursor: pointer;
}

.navchild {
  width: 140px;
  height: 0px;
  background: #fff;
  transition: 0.6s;
  position: absolute;
  top: 80px;
  left: -10px;
}

.navchildgywm {
  width: 140px;
  height: 0px;
  background: #fff;
  transition: 0.6s;
  position: absolute;
  top: 80px;
  left: -10px;
}

.navchild1 {
  margin: 0 10px;
  height: 0px;
  line-height: 0px;
  background: #fff;
  text-align: center;
  font-size: 14px;
  color: #222;
  opacity: 0;
  cursor: pointer;
  transition: 0.2s;
}

/* .navchild1:hover a{
              color:red;
          } */
.navchild2 {
  border-bottom: 1px solid #ededed;
}

.navhover:hover .navchild {
  height: 140px;
  transition: 0.6s;
}

.navhover:hover .navchildgywm {
  height: 185px;
  transition: 0.6s;
}

.navhover:hover .navchild1 {
  height: 45px;
  line-height: 45px;
  opacity: 1;
  transition: 0.2s;
}

</style>


// WEBPACK FOOTER //
// src/components/common/nav.vue